import { Link } from "react-router-dom";
import { getNewsFeed } from "@/lib/movieData";

export default function NewsSection() {
  const news = getNewsFeed(6);

  return (
    <section className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1180px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-7">
            <div>
              <p className="text-[11px] tracking-[0.3em] text-foreground-400 uppercase">Newsroom</p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">资讯速递</h2>
              <p className="mt-2 text-sm text-foreground-600">定档、预告、幕后与口碑动态，一站看完</p>
            </div>
            <span className="text-xs text-foreground-400 whitespace-nowrap">每日更新 · 演示数据</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
            {news.map((item) => {
              const [year, month, day] = item.date.split("-");
              return (
                <Link
                  key={`${item.movieId}-${item.title}`}
                  to={`/detail/${item.movieId}`}
                  className="group flex items-start gap-4 py-5 border-b border-background-300/70 cursor-pointer"
                >
                  <div className="w-14 shrink-0 text-center">
                    <p className="font-heading text-xl text-primary-600 leading-none">{day}</p>
                    <p className="mt-1.5 text-[10px] tracking-wider text-foreground-500">
                      {year}.{month}
                    </p>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm md:text-[15px] leading-relaxed text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {item.title}
                    </h3>
                    <div className="mt-2 flex items-center gap-2">
                      <span className="inline-flex items-center h-5 px-2 rounded bg-secondary-100 text-[10px] text-secondary-900">
                        {item.movieTitle}
                      </span>
                      <span className="text-[11px] text-foreground-400">电影资讯</span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-accent-500 transition-colors mt-1"></i>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}